<div class="box green_box"></div>
<div class="box pink_box"></div>
<main class="rights" [@fadeInAnimation]>
  <cradua-report-search
    [subSubGroups]="subSubGroup$ | async"
    [subGroups]="subGroup$ | async"
    [groups]="group$ | async"
    [acquisitionTypes]="acquisitionType$ | async"
    [cofOStatus]="cofOStatus$ | async"
    [task]="task"
    [landTitle]="landTitle$ | async"
    [view]="view"
    (searchEmit)="onSearch($event)"
    (emitTask)="onTask($event)"
    >
    </cradua-report-search>


    <cradua-land-title-report
    [landTitles]="landTitle$ | async"
    [subSubGroups]="subSubGroup$ | async"
    [subGroups]="subGroup$ | async"
    [groups]="group$ | async"
    [measures]="measure$ | async"
    [currencies]="currency$ | async"
    [activities]="activities"
    [acquisitionTypes]="acquisitionType$ | async"
    *ngIf="
          !(isLoadingLandTitle$ | async)  &&
          !(isLoadingAcquisitionType$ | async) &&
          !(isLoadingCurrency$ | async) &&
          !(isLoadingMeasure$ | async) &&
          !(isLoadingSubSubGroup$ | async) &&
          !(isLoadingGroup$ | async) &&
          !(isLoadingSubGroup$ | async) &&
          !(isLoadingCofOStatus$ | async) &&
          !(isLoadingLandParcel$ | async)
        "
    ></cradua-land-title-report>

    <cradua-list-spinner
    *ngIf="
    ((isLoadingLandTitle$ | async))||
      (isLoadingAcquisitionType$ | async) ||
      (isLoadingCurrency$ | async) ||
      (isLoadingMeasure$ | async) ||
      (isLoadingSubSubGroup$ | async) ||
      (isLoadingGroup$ | async) ||
      (isLoadingSubGroup$ | async) ||
      (isLoadingCofOStatus$ | async) ||
      (isLoadingLandParcel$ | async)
    "
  >
  </cradua-list-spinner>
</main>

